import { login, getInfo } from '@/api/auth'
import { clearTabsStorage, getCurrentUserId } from '@/utils/tabs'

const state = {
  token: '',
  user: {}
}

const getters = {
  isAuthenticated: (state) => !!state.token,
  currentUser: (state) => state.user || {},
  isAdmin: (state) => state.user?.isAdmin === true || state.user?.role === 'admin' || state.user?.role === 'superadmin'
}

const mutations = {
  SET_TOKEN(state, token) {
    state.token = token
  },
  SET_USER(state, user) {
    state.user = user || {}
  },
  CLEAR_AUTH(state) {
    state.token = ''
    state.user = null
  }
}

const actions = {
  async login({ commit }, credentials) {
    try {
      const response = await login(credentials)

      if (!response || !response.data) {
        throw new Error('登录响应格式错误')
      }

      const { token, user } = response.data
      if (!token || !user) {
        throw new Error('登录响应缺少必要数据')
      }

      const expiresAt = new Date().getTime() + 
        (credentials.rememberMe ? 7 * 24 * 60 * 60 * 1000 : 24 * 60 * 60 * 1000)
      
      const isAdmin = user?.role === 'admin' || user?.role === 'superadmin' || user?.isAdmin === true || false
      const userData = {
        ...user,
        isAdmin,
        role: user?.role || 'user'
      }
      
      commit('SET_TOKEN', token)
      commit('SET_USER', userData)

      localStorage.setItem('token', token)
      localStorage.setItem('tokenExpiresAt', expiresAt)
      localStorage.setItem('user', JSON.stringify(userData))
      localStorage.setItem('isAdmin', isAdmin)
      localStorage.setItem('role', user.role)
      
      return true
    } catch (error) {
      console.error('Login error:', error)
      throw error
    }
  },

  logout({ commit, dispatch }) {
    // 清当前用户 tabs 存储与内存状态
    clearTabsStorage(getCurrentUserId())
    dispatch('tabs/clearAll', null, { root: true })

    localStorage.removeItem('token')
    localStorage.removeItem('tokenExpiresAt')
    localStorage.removeItem('user')
    localStorage.removeItem('isAdmin')
    localStorage.removeItem('role')

    commit('CLEAR_AUTH')

    // 重定向到登录页面
    window.location.href = '/auth/login'
  },

  checkAuth({ dispatch }) {
    const token = localStorage.getItem('token')
    const expiresAt = localStorage.getItem('tokenExpiresAt')
    
    if (!token || !expiresAt) {
      dispatch('logout')
      return false
    }
    
    if (new Date().getTime() > parseInt(expiresAt)) {
      dispatch('logout')
      return false
    }
    
    return true
  },

  async fetchUserInfo({ commit }) {
    const { data } = await getInfo()
    const u = data.user || {}
    const isAdmin = u.role === 'admin' || u.role === 'superadmin' || u.isAdmin === true
    const userData = { ...u, isAdmin }
    commit('SET_USER', userData)
    localStorage.setItem('user', JSON.stringify(userData))
    localStorage.setItem('isAdmin', String(isAdmin))
    if (u.role) localStorage.setItem('role', u.role)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
} 